// app/hub/[bookmaker]/types.ts
export type AnchorType =
  | 'overview'
  | 'bonus'
  | 'features'
  | 'esport'
  | 'payments'
  | 'expert';

export enum Anchors {
  overview = 'Overview',
  bonus = 'Bonus offer',
  features = 'Features',
  esport = 'Esports',
  payments = 'Payments',
  expert = 'Expert review',
}
